<template>
    <div class="delivery-makeVideo-detail">
        <el-row class="device-drink-title">
            <el-col :span="5">
                <span class="h3">{{$t('zhi_zuo_shi_pin_bian_ji')}}</span>
                <router-back/>
            </el-col>
        </el-row>
        <div :gutter="20" class="delivery-makeVideo-detail-info">
            <upload class="upload" :url="makeVideo.url+'?x-oss-process=video/snapshot,t_1000,f_jpg,w_1024,h_600,m_fast'"
                    :tip="$t('tip_logo')"
                    :uploadSuccess="uploadSuccess"></upload>
        </div>

        <div class="device-drink-data-list">
            <div>
                <span class="device-title">{{$t('xiang_guan_she_bei')}}</span>
                <el-button size="mini" type="primary" @click="allocatedVisible=true">{{$t('bang_ding_she_bei')}}</el-button>
            </div>
            <el-table :data="devices">
                <el-table-column :label="$t('she_bei_ming_cheng')" align="center" prop="name"></el-table-column>
                <el-table-column :label="$t('she_bei_bian_hao')" align="center" prop="uuid"></el-table-column>
                <el-table-column :label="$t('chan_pin_ming_chen')" align="center" prop="productName"></el-table-column>
                <el-table-column :label="$t('cao_zuo')" align="center" prop="name">
                    <template slot-scope="scope">
                        <span @click="handleDelete(scope.row)"
                              class="device-drink-edit">{{$t('shan_chu')}}</span>

                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                @current-change="handleCurrentChange"
                class="pagination"
                :current-page="pagination.curPage"
                :page-size="pagination.limit"
                layout="total, prev, pager, next, jumper"
                :total="pagination.total">
        </el-pagination>

        <c-dialog class="dialog" :visible.sync="allocatedVisible" :width="'50rem'" :height="'37.5rem'"
                  :outer-close="false"
                  :title="$t('fen_pei_she_bei')">

            <el-button slot="title" size="mini" type="primary" @click="deviceAllocate">{{$t('bao_cun')}}</el-button>

            <allocation-device ref="allocDevice" slot="default"></allocation-device>
        </c-dialog>

    </div>

</template>

<script>
    import CDialog from '@/components/Dialog'
    import Upload from '@/components/Upload'
    import AllocationDevice from '@/components/AllocateDevice'
    import {makeVideoUpdate, makeVideoDeviceUnion, makeVideoDeviceList, makeVideoDeviceBind, makeVideoDeviceUnBind} from '@/api/delivery/device/makeVideo'
    export default {
        name: '',
        components: {
            Upload,
            CDialog,
            AllocationDevice
        },
        activated: function () {
            this.pagination.uuid = this.$route.params.uuid
            for (let item in this.$route.params) {
                if (this.makeVideo.hasOwnProperty(item)) {
                    this.makeVideo[item] = this.$route.params[item]
                }
            }
            this.loadDevices()
        },
        data: function () {
            return {
                makeVideo: {
                    uuid: '',
                    url: '',
                },
                devices: [],
                allocatedVisible: false,
                pagination: {
                    uuid: '',
                    start: 0,
                    curPage: 1,
                    limit: 10,
                    total: 0,
                },
            }
        },
        methods: {
            handleCurrentChange(value){
                this.pagination.curPage = value
                this.pagination.start = (value - 1) * this.pagination.limit
                makeVideoDeviceList(this.pagination).then(res => {
                    this.devices = res.data
                })
            },

            deviceAllocate(){
                let vue = this
                let devices = vue.$refs.allocDevice.deviceAllocate()
                if (!devices.length) {
                    this.$message.warning('请选取需要分配的设备')
                } else {
                    makeVideoDeviceBind({uuid: this.pagination.uuid, deviceUuids: devices}).then(() => {
                        vue.loadDevices()
                        vue.allocatedVisible = false
                    })
                }
            },

            loadDevices() {
                let vue = this
                makeVideoDeviceUnion(this.pagination).then(res => {
                    vue.devices = res.data.list || []
                    vue.pagination.total = parseInt(res.data.total)
                })
            },


            handleDelete(row) {
                this.$confirm('此操作将删除设备制作视频, 是否继续?', this.$t('ti_shi'), {
                    confirmButtonText: this.$t('que_ding'),
                    cancelButtonText: this.$t('qu_xiao'),
                    type: 'warning'
                }).then(() => {
                    makeVideoDeviceUnBind({deviceUuid: row.uuid, uuid: this.pagination.uuid}).then(res => {
                        if (res.code === 0) {
                            this.$message.success('移除成功')
                            this.loadDevices()
                        }
                    })
                }).catch(() => {

                })
            },
            uploadSuccess(url){
                this.makeVideo.url = url

                makeVideoUpdate(this.makeVideo).then(() => {
                    this.$message.success('更新成功')
                })
            }
        },
    }
</script>

<style lang="scss">
    .delivery-makeVideo-detail {
        .delivery-makeVideo-detail-info {
            padding: 0 $padding;
            height: 200px;
            .upload {
                height: 150px;
                width: 256px;
                margin: auto;
            }
        }

        .device-title {
            display: inline-block;
            margin-right: $padding;
        }

        .drink-sort-save {
            border-color: $f_color;
            color: $f_color;
        }

        .drink-sort-sync {
            border-color: $btn_sec_color;
            color: $btn_sec_color;
        }

        .drink-sort-save:hover {
            background-color: $f_color;
            color: $f-th_color;
        }
        .drink-sort-sync:hover {
            background-color: $btn_sec_color;
            color: $f-th_color;
        }

        .device-drink-edit {
            color: $btn_sec_color;
            cursor: pointer;
        }
    }
</style>
